import React from 'react';

import { VariantNode } from '@candu-ai/styleguide/types';
import { Variants } from 'craft/containers/Toolbox/components';
import { useMultiNodes } from 'craft/hooks';

interface Props {
  nodeIds: string[];
}

export const ButtonBadgesVariantSelectorToolbox = ({ nodeIds }: Props) => {
  const {
    props,
    type,
    actions: { setProps },
  } = useMultiNodes(nodeIds);

  const colorMatchedVariant = props.color.value === 'primary' ? 'base' : props.color.value;
  const appearanceStyle = props.outline.value === 'light' ? '_light' : '';
  return (
    <Variants
      name={props.variant?.value || `${colorMatchedVariant}${appearanceStyle}` || 'base'}
      componentName={type}
      onSelectVariant={(variant: VariantNode) => setProps(variant.conditions)}
      conditions={{
        color: props.color.value,
        outline: props.outline.value,
      }}
    />
  );
};
